// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"784d0c36","513":"c6581007","703":"c02b2e77","787":"04ade30a"}[chunkId] + ".chunk.js";
};